import context from './context/reducer';
import alert from 'src/typescript/components/alert/reducer';
import modal from './modal/reducer';
import featureFlag from 'src/utils/featureFlag';

const reducers = {
  context,
  alert,
  featureFlag,
  modal,
};

export default reducers;
